import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircleIcon } from 'lucide-react';
export function Services() {
  const process = [{
    step: 'Book',
    desc: 'Schedule your repair online or by phone'
  }, {
    step: 'Diagnose',
    desc: 'Engineer inspects and assesses the fault'
  }, {
    step: 'Repair',
    desc: 'Professional repair completed'
  }, {
    step: 'Test',
    desc: 'Appliance tested and verified working'
  }];
  const servicePackages = [{
    title: 'Engineer Callout & Diagnostics',
    price: '£99',
    description: 'Fixed visit to assess fault and quote for repairs. Parts approved before fitting.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pSjcZvwzYPPvsjKTC7L8b3/12._Washing_Machine.png',
    alt: "Engineer diagnosing washing machine in customer's kitchen – professional diagnostics",
    features: ['Professional fault assessment', 'Transparent repair quote', 'Parts approval before fitting', 'Expert engineer visit'],
    stripeLink: '#' // Placeholder - user will provide actual Stripe link
  }, {
    title: 'One-Year Repair Service (TV + Set-Top Box)',
    price: '£120',
    description: 'Fast response for TV faults and connection issues. Engineer visits scheduled promptly. Friendly support every step of the way.',
    image: 'https://images.unsplash.com/photo-1522869635100-9f4c5e86aa37?w=800&h=600&fit=crop',
    alt: 'Family watching TV in comfortable living room – entertainment system repair service',
    features: ['Fast response for TV faults', 'Connection issue diagnostics', 'Promptly scheduled visits', 'Friendly support throughout'],
    stripeLink: '#' // Placeholder - user will provide actual Stripe link
  }, {
    title: 'Two-Year Repair Service (1 Appliance)',
    price: '£150',
    description: 'Extended engineer support for one appliance. Diagnostics, repairs and standard parts (when available). Priority booking for the full term.',
    image: 'https://images.unsplash.com/photo-1556911220-bff31c812dba?w=800&h=600&fit=crop',
    alt: 'Modern kitchen with fridge and oven – appliance repair and maintenance service',
    features: ['Extended engineer support', 'Diagnostics and repairs included', 'Standard parts when available', 'Priority booking for full term'],
    stripeLink: '#' // Placeholder - user will provide actual Stripe link
  }];
  return <div className="w-full bg-slate-50 py-16" data-id="element-522">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-523">
        <div className="text-center mb-12" data-id="element-524">
          <h1 className="text-4xl font-bold text-slate-800 mb-4" data-id="element-525">
            Our Repair Services
          </h1>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto" data-id="element-526">
            We handle diagnostics and repairs for most home appliances across
            the UK
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-md p-8 mb-16" data-id="element-527">
          <h2 className="text-2xl font-bold text-slate-800 mb-8 text-center" data-id="element-528">
            How Our Service Works
          </h2>
          <div className="grid md:grid-cols-4 gap-8" data-id="element-529">
            {process.map((item, index) => <div key={index} className="text-center" data-id="element-530">
                <div className="bg-teal-600 text-white w-12 h-12 rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-4" data-id="element-531">
                  {index + 1}
                </div>
                <h3 className="font-semibold text-slate-800 mb-2" data-id="element-532">
                  {item.step}
                </h3>
                <p className="text-sm text-slate-600" data-id="element-533">{item.desc}</p>
              </div>)}
          </div>
        </div>
        <div className="mb-12" data-id="element-534">
          <h2 className="text-3xl font-bold text-slate-800 mb-8 text-center" data-id="element-535">
            Service Packages
          </h2>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-536">
            {servicePackages.map((pkg, index) => <div key={index} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition" data-id="element-537">
                <div className="relative h-64" data-id="element-538">
                  <img src={pkg.image} alt={pkg.alt} className="w-full h-full object-cover" data-id="element-539" />
                </div>
                <div className="p-6" data-id="element-540">
                  <h3 className="text-2xl font-bold text-slate-800 mb-2" data-id="element-541">
                    {pkg.title}
                  </h3>
                  <div className="text-3xl font-bold text-teal-600 mb-4" data-id="element-542">
                    {pkg.price}
                  </div>
                  <p className="text-slate-600 mb-6" data-id="element-543">{pkg.description}</p>
                  <ul className="space-y-2 mb-6" data-id="element-544">
                    {pkg.features.map((feature, i) => <li key={i} className="flex items-start gap-2" data-id="element-545">
                        <CheckCircleIcon className="w-5 h-5 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-546" />
                        <span className="text-sm text-slate-700" data-id="element-547">
                          {feature}
                        </span>
                      </li>)}
                  </ul>
                  <a href={pkg.stripeLink} className="block w-full bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition text-center" data-id="element-548">
                    Pay Securely (Stripe)
                  </a>
                </div>
              </div>)}
          </div>
        </div>
        <div className="bg-teal-50 rounded-xl p-8 text-center" data-id="element-549">
          <h2 className="text-2xl font-bold text-slate-800 mb-4" data-id="element-550">
            Need Help Choosing?
          </h2>
          <p className="text-slate-600 mb-6 max-w-2xl mx-auto" data-id="element-551">
            Contact us for a free consultation. Our team will help you select
            the right service for your appliance needs.
          </p>
          <div className="flex flex-wrap gap-4 justify-center" data-id="element-552">
            <a href="tel:08000554969" className="bg-teal-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-teal-700 transition" data-id="element-553">
              Call 0800 055 4969
            </a>
            <Link to="/contact" className="border-2 border-teal-600 text-teal-600 px-8 py-3 rounded-lg font-semibold hover:bg-teal-600 hover:text-white transition" data-id="element-554">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </div>;
}